import React, { useState } from 'react';
import classnames from 'classnames';
import Radio from './Radio';
import { ENTER_KEYDOWN, SPACE_KEYDOWN } from '../../constants/keydown';
import makeBodyText from '../../utils/makeText';
import styles from './index.module.scss';
// eslint-disable-next-line
import '@styles_cnDS/cards.scss';
import Tooltip from '../Tooltip';
const RadioInit = ({ id, name, withLabel, label, isSelected, isError, isDisabled, isFullWidth, onClick, withCard, disableRadioCircle, cardName, showToolTip }) => {
    const [isHovered, setIsHovered] = useState(false);
    const _handleClick = (e) => {
        !isDisabled && !isError && !isSelected && onClick && onClick(e, id);
    };
    const _handleKeyDown = (e) => {
        if ([ENTER_KEYDOWN, SPACE_KEYDOWN].includes(e.keyCode)) {
            !isDisabled && !isError && !isSelected && onClick && onClick(e, id);
        }
    };
    const setHover = () => {
        setIsHovered(!isHovered);
    };
    const classNames = classnames({
        [styles.radioItem]: true,
        [styles.error]: withLabel && isError,
        [styles.selected]: withLabel && isSelected,
        [styles.fullWidth]: withLabel && isFullWidth,
        [styles.disabled]: withLabel && isDisabled,
        [styles.withLabel]: withLabel,
        [styles.withoutCircle]: disableRadioCircle
    });
    return (React.createElement("div", Object.assign({ id: id, tabIndex: 0, role: 'button', className: classNames, onClick: _handleClick, onKeyDown: _handleKeyDown }, (isDisabled && showToolTip ?
        {
            onMouseEnter: setHover,
            onMouseLeave: setHover,
            onFocus: setHover,
            onBlur: setHover
        } :
        {})),
        isDisabled && showToolTip && (React.createElement(Tooltip, { useClick: true, withoutChild: true, forceShow: isDisabled && isHovered, label: 'This field isn\'t available' })),
        !disableRadioCircle && (React.createElement(Radio, { id: id, name: name, isError: isError, isSelected: isSelected, isDisabled: isDisabled, onClick: _handleClick, withLabel: withLabel })),
        withLabel && React.createElement("span", { className: `${makeBodyText('L')} ${styles.text}` }, label),
        withCard && cardName && React.createElement("i", { className: `${cardName} card ${styles.card}` })));
};
export default RadioInit;
